import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const itemApi = createApi({
  reducerPath: "itemApi",
  baseQuery: appBaseQuery,
  tagTypes: ["Item"],
  endpoints: (builder) => ({
    getItems: builder.query({
      query: (params = {}) => buildPagedListUrl("item/", params),
      providesTags: ["Item"],
    }),
    addItem: builder.mutation({
      query: (newItem) => ({
        url: "item/",
        method: "POST",
        body: newItem,
      }),
      invalidatesTags: ["Item"],
    }),
    updateItem: builder.mutation({
      query: ({ uid, ...updatedItem }) => ({
        url: `item/${uid}`,
        method: "PUT",
        body: updatedItem,
      }),
      invalidatesTags: ["Item"],
    }),
    deleteItem: builder.mutation({
      query: (uid) => ({
        url: `item/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Item"],
    }),
  }),
});

export const {
  useGetItemsQuery,
  useLazyGetItemsQuery,
  useAddItemMutation,
  useUpdateItemMutation,
  useDeleteItemMutation,
} = itemApi;
